import React, { useEffect, useState } from 'react';
import PaginationOptions, { Page } from '../../../../api/ui/paginationOptions';
import { useDispatch } from 'react-redux';
import {
  DEFAULT_END_AT,
  DEFAULT_START_AT,
  DEFAULT_START_AT_30_DAYS,
} from '../../constants';
import { Helmet } from 'react-helmet';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import TextField from '@mui/material/TextField';
import Visible from '../../../../components/Custom/Visible';
import PaginationComponent from '../../../../components/Custom/PaginationComponent';
import Notification from '../../../../components/Notification/Notification';
import { nftRentalLogListRequest } from '../../../../redux/actions/log/nftRentalLogAction';
import useTranslation from '../../../../hooks/useTranslation';
import useSchemaRentalLog from '../../../../schema/table-schema/useSchemaRentalLog';
import BOTable from '../../../../components/Tables/BOTable';

function RentalLogMain() {
  // -- component const --//
  // 페이지 제목
  const title = 'admin.log.perplay.rental.title'; // '차량 렌탈 로그';

  const OPTION_KEY = Page.LOG_PERPLAY_RESETSTATS;

  const { t } = useTranslation();
  const { schema } = useSchemaRentalLog();

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  // -- state --//
  const [logList, setLogList] = useState();
  const [totalCount, setTotalCount] = useState(0);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 페이지 옵션
  const [pageOption, setPageOption] = useState();
  const [pageLength, setPageLength] = useState(25);
  const [page, setPage] = useState(1);

  const [startAt, setStartAt] = useState(DEFAULT_START_AT_30_DAYS);
  const [endAt, setEndAt] = useState(DEFAULT_END_AT);

  // 로딩
  const [isLoading, setIsLoading] = useState(false);

  // 검색
  const [account, setAccount] = useState('');
  const [nftUid, setNftUid] = useState(0);

  // -- func & handler --//
  const fetchList = () => {
    setIsLoading(true);

    dispatch(
      nftRentalLogListRequest({
        page: page,
        pageLength: Number(pageLength),
        beginDate: startAt,
        endDate: endAt,
        account: account,
        nftUid: nftUid,
        callback: (data) => {
          console.log(data);
          setIsLoading(false);
          setLogList(data.list);
          setTotalCount(data.totalCount);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);
          setIsLoading(false);
        },
      }),
    );
  };

  const handlePageChange = (_, value) => {
    setPage(Number(value));
  };

  const handlePageLengthChange = (value) => {
    setPageLength(value);
    setPage(1);
  };

  const handleSearchClick = () => {
    if (page === 1) {
      fetchList();
      return;
    }

    setPage(1);
  };

  // -- react hooks --//
  useEffect(() => {
    PaginationOptions.getInstance().then((instance) => {
      const option = instance?.getData(OPTION_KEY);
      setPageOption(option);

      if (option.list_count_elements?.length > 0) {
        setPageLength(Number(25));
      }
    });
  }, [OPTION_KEY]);

  useEffect(() => {
    fetchList();
  }, [page, pageLength]);

  // -- render --//
  return (
    <div className="page">
      <Helmet>
        <title>{t(title)}</title>
      </Helmet>

      <div className="topSection">
          <div className="leftSection">
              <p className="titleText">{t(title)}</p>
          </div>
      </div>

      <div className="spaceDiv10"/>

      <div className="contentsArea paddingAll">
        <div className="rowDiv">
          <div className="titleDiv">
            검색 기준
          </div>

          <div className="spaceDiv10"/>

          <div className="descDiv date">
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DateTimePicker
                value={startAt}
                onChange={(date) => {
                  setStartAt(date.format('YYYY-MM-DDTHH:mm:ss'));
                }}
                renderInput={(params) => (
                  <TextField {...params} variant="standard"/>
                )}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DateTimePicker
                value={endAt}
                onChange={(date) => {
                  setEndAt(date.format('YYYY-MM-DDTHH:mm:ss'));
                }}
                renderInput={(params) => (
                  <TextField {...params} variant="standard"/>
                )}
              />
            </LocalizationProvider>

            <input
              className=""
              value={account}
              placeholder="유저 이메일 또는 ID"
              onChange={(e) => {
                setAccount(e.target.value);
              }}
            />

            <input
              className=""
              value={nftUid === 0 ? '' : nftUid}
              placeholder="NFT 고유 번호"
              onChange={(e) => {
                setNftUid(Number(e.target.value));
              }}
            />

            <button className="defaultBtn" onClick={handleSearchClick}>
              조회
            </button>
          </div>
        </div>
      </div>

      <div className="spaceDiv10"/>

      <Visible Visible visible={pageOption?.top_paging}>
        <PaginationComponent
          disable={false}
          option={pageOption}
          page={page}
          pageLength={pageLength}
          totalCount={totalCount}
          onChange={handlePageChange}
          onSelect={handlePageLengthChange}
        />
      </Visible>

      <div className="spaceDiv10"/>

      <BOTable
        schema={schema}
        rows={logList}
        loading={isLoading}
        onClick={null}
      />

      <div className="spaceDiv10"/>

      <Visible Visible visible={pageOption?.bottom_paging}>
        <PaginationComponent
          disable={false}
          option={pageOption}
          page={page}
          pageLength={pageLength}
          totalCount={totalCount}
          onChange={handlePageChange}
          onSelect={handlePageLengthChange}
        />
      </Visible>

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}
    </div>
  );
}

export default RentalLogMain;
